import { render } from "./UserHome.component.vue?vue&type=template&id=1629957b"
import script from "./UserHome.component.vue?vue&type=script&lang=js"
export * from "./UserHome.component.vue?vue&type=script&lang=js"

import "./UserHome.component.vue?vue&type=style&index=0&id=1629957b&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__